const days = [
    {
        id:1,
        timeList:[
             {
                 value:1,
                 label:'3'
             },
        ]
    },
    {
        id:2,
        timeList:[
             {
                 value:1,
                 label:'5'
             },
             {
                 value:2,
                 label:'7'
             }
        ]
    },
    {
        id:3,
        timeList:[
             {
                 value:1,
                 label:'3'
             },
             {
                 value:2,
                 label:'5'
             },
             {
                value:2,
                label:'7'
            }
        ]
     },
    {
       id:4,
       timeList:[
            {
                value:1,
                label:'3'
            },
            {
                value:2,
                label:'5'
            }
       ]
    },
    {
        id:5,
        timeList:[
             {
                 value:1,
                 label:'3'
             },
             {
                 value:2,
                 label:'5'
             }
        ]
     }  
]
export default {
    days
}